<template>
  <div class="page-stack">
    <div class="sticky-toolbar">
    <a-card :bordered="false" class="sticky-toolbar-card">
      <a-space wrap align="center">
        <div style="font-weight:600">Дата:</div>
        <a-button @click="shiftDate(-1)"><LeftOutlined /></a-button>
        <a-date-picker v-model:value="dateValue" format="YYYY-MM-DD" :allowClear="false" inputReadOnly @change="load" />
        <a-button @click="shiftDate(1)"><RightOutlined /></a-button>
        <a-button @click="load" :loading="loading">Обновить</a-button>
      </a-space>
    </a-card>
    </div>

    <a-card title="Итого по приёмам" :bordered="false">
      <a-table :dataSource="mealsRows" :columns="mealsCols" rowKey="meal" :pagination="false" size="small" />
    </a-card>

    <a-card title="Итого по особым" :bordered="false">
      <a-table :dataSource="specialRows" :columns="specialCols" :pagination="false" size="small" />
    </a-card>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
import { http } from '../../api/http'

const dateValue = ref(dayjs())
const loading = ref(false)
const raw = ref(null)

const mealsCols = [
  { title: 'Приём', dataIndex: 'meal' },
  { title: 'Итого', dataIndex: 'total_qty' },
]
const specialCols = [
  { title: 'Приём', dataIndex: 'meal' },
  { title: 'Особое', dataIndex: 'special_name' },
  { title: 'Итого', dataIndex: 'total_qty' },
]

const mealsRows = computed(() => raw.value?.data?.meals || [])
const specialRows = computed(() => raw.value?.data?.specials || [])

function dateStr() {
  return dateValue.value.format('YYYY-MM-DD')
}

function shiftDate(days) {
  dateValue.value = dayjs(dateValue.value).add(days, 'day')
  load()
}

async function load() {
  loading.value = true
  try {
    const r = await http.get(`/api/kitchen/summary?date=${encodeURIComponent(dateStr())}`)
    raw.value = r.data
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Не удалось загрузить сводку')
  } finally {
    loading.value = false
  }
}

load()
</script>

<style scoped>
.page-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.sticky-toolbar {
  position: sticky;
  top: 16px;
  z-index: 20;
}

.sticky-toolbar-card :deep(.ant-card-body) {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
}

@media (max-width: 767px) {
  .sticky-toolbar {
    top: 8px;
  }
}
</style>
